export const environment = {

  production           : true,
  federatedAuth        : true,
  executionEnvironment : "production",
  localhostUrl         : window.location.origin,
  user                 : "",
  pwd                  : "",

};


// WEBPACK FOOTER //
// ./src/environments/environment.ts